import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex',
    gap: `${theme.spacing(5)} !important`,
    flexDirection: 'row',
  },
  verticalDivider: {
    width: '1px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: theme.palette.dividerV2.main,
  },
  videoContainer: {
    position: 'relative',
    width: theme.spacing(46.875),
    height: theme.spacing(26.375),
    margin: `${theme.spacing(0)}, auto`,
  },
  thumbnailImages: {
    width: theme.spacing(46.875),
    height: theme.spacing(26.375),
    display: 'block',
    cursor: 'pointer',
    borderRadius: theme.spacing(0.5),
  },
  videoWrapper: {
    width: theme.spacing(50.875),
    flexShrink: 0,
    backgroundColor: theme.palette.textBackground.light,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2, 2, 2, 2),
    gap: theme.spacing(2),
    borderRadius: theme.spacing(1),
    maxHeight: theme.spacing(35.375),
    boxSizing: 'border-box',
  },
  thumbnailWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  playButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    width: theme.spacing(5.5),
    height: theme.spacing(5.5),
    border: 'none',
    boxSizing: 'border-box',
    opacity: '0.24',
    backgroundColor: theme.palette.black.dark,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectCurrencySection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  selectCurrencyHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  selectCurrencySelector: {
    marginBottom: theme.spacing(3),
  },
  playIcon: {
    color: theme.palette.stages.default,
  },
  stepHeading: {
    display: 'flex',
    alignItems: 'center',
  },
  stepLabel: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    marginLeft: theme.spacing(1),
  },
}))
